import React from 'react';
import TpEvaluatorService from '../../../Services/TpEvaluatorService';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpEvaluatorPersonaSearchParams from './TpEvaluatorPersonaSearchParams';
import TpEvaluatorPersonaItem from '../../../Domain/TpEvaluatorPersonaItem';

class TpEvaluatorPersonaAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpEvaluatorPersonaSearchParams(),
      cleared: process.env.NODE_ENV !== 'development',
    };
    this.startSearch = this.startSearch.bind(this);
    this.handleExportOnClick = this.handleExportOnClick.bind(this);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
      cleared: false,
    });
  }

  handleExportOnClick() {
    TpEvaluatorService.ExportToExcelForView(this.state.searchItem).catch(() => ErrorMessage.SetErrorMessage('TPEPA31'));
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={TpEvaluatorPersonaItem}
          serviceFunction={TpEvaluatorService.GetAllItemBySearchingForPersona}
          convertDBItemsFunction={TpEvaluatorService.ConvertDBItemsForPersona}
          searchParamsType={TpEvaluatorPersonaSearchParams}
          orderDirection={OrderDirectionsEnum.Asc}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          cleared={this.state.cleared}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name or email...'
          errorCode='TPEPA52'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportOnClick}
        />
      </div>
    );
  }
}

export default TpEvaluatorPersonaAdmin;
